import axios from "axios";


export const axiosRequest = axios.create({
    baseURL: "https://staging.wordsru.com/backend/api/v1"
});
